import React from 'react'
import { Icon } from '@iconify/react'
import { useNav, useParseQuery } from '../../hooks/useNav'
import { MdVisibilityOff } from 'react-icons/md'


const Table = ({
  data,
  detailView,
  startRowIndex,
  columnMapping,
  columnWidths,
  actionButtons,
  emptyRowCount,
  selectedList = null,
  toggleSelect,
  selectAll,
  toggleSelectAll,
  checkBorrow,
  
}) => {
  const marginRight = checkBorrow ? `mr-40` : `mr-52`
  const MainTable = () => (
    <div className={`${marginRight} overflow-x-auto`}>
      <table className="w-full table-fixed">
        <thead className="bg-ivory text-center font-semibold">
          <tr>
            {selectedList ? (
              <th className="h-[5.8vh] w-[3.33vw] items-center justify-center px-3 text-black">
                <div className="flex h-[5.8vh] items-center justify-center">
                  <label className="relative h-6 w-6 cursor-pointer">
                    <input
                      type="checkbox"
                      className="hidden"
                      checked={selectAll}
                      onChange={() => toggleSelectAll()}
                    />
                    <div
                      className={`flex h-5 w-5 items-center justify-center rounded-[4px] border-[3px] ${
                        selectAll
                          ? 'border-gray-accent bg-[#5B5B5B]'
                          : 'border-gray-accent bg-white'
                      }`}
                    >
                      {selectAll && (
                        <Icon
                          icon="ph:check-bold"
                          width="24px"
                          height="24px"
                          style={{ color: 'white' }}
                        />
                      )}
                    </div>
                  </label>
                </div>
              </th>
            ) : null}
            <th
              className={`h-[5.8vh] w-[4vw] items-center border border-lightgray px-2 text-center`}
            >
              <p className="flex h-[5.8vh] items-center justify-center text-center text-sm leading-tight">
                STT
              </p>
            </th>
            {columnMapping.map((item, index) => (
              <th
                key={index}
                className={`${columnWidths[item.key]} h-[5.8vh] items-center border border-lightgray px-2 text-center`}
              >
                <p className="flex h-[5.8vh] items-center justify-center overflow-hidden whitespace-nowrap text-sm leading-tight">
                  {item.value}
                </p>
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="h-fit">
          {data.map((row, rowIndex) => (
            <tr
              key={row.id || rowIndex}
              className={`whitespace-nowrap ${(row.activate === 'Chưa kích hoạt' && row.status) || row.status === 'INACTIVE' ? 'bg-ivory text-secondarygray' : 'bg-white'}`}
            >
              {selectedList ? (
                <td className="flex h-[5.8vh] w-[3.33vw] items-center justify-center border border-light-gray px-3">
                  <label className="relative h-6 w-6 cursor-pointer">
                    <input
                      type="checkbox"
                      className="hidden"
                      checked={selectedList.has(row.id)}
                      onChange={() => toggleSelect(row)}
                    />
                    <div
                      className={`flex h-5 w-5 items-center justify-center rounded-[4px] border-[3px] ${
                        selectedList.has(row.id)
                          ? 'border-gray-accent bg-[#5B5B5B]'
                          : 'border-gray-accent bg-white'
                      }`}
                    >
                      {selectedList.has(row.id) && (
                        <Icon
                          icon="ph:check-bold"
                          width="24px"
                          height="24px"
                          style={{ color: 'white' }}
                        />
                      )}
                    </div>
                  </label>
                </td>
              ) : null}
              <td className="h-[5.8vh] border border-lightgray px-3 text-center">
                {startRowIndex + rowIndex}
              </td>
              {columnMapping.map((item, colIndex) => (
                <td
                  key={colIndex}
                  className="h-[5.8vh] border border-lightgray px-3"
                >
                  {colIndex === 0 ? (
                    item.key === 'titleBorrow' ? (
                      <div className="h-[5.2vh] overflow-hidden whitespace-nowrap hover:cursor-pointer hover:overflow-x-auto">
                        {row[item.key]}
                      </div>
                    ) : (
                      <div
                        className="h-[5.2vh] overflow-hidden whitespace-nowrap text-link underline hover:cursor-pointer hover:overflow-x-auto"
                        onClick={() => detailView(row)}
                      >
                        {row[item.key]}
                      </div>
                    )
                  ) : item.key === 'getInforFromUUID' ? (
                    <div
                      className="h-[5.2vh] overflow-hidden whitespace-nowrap text-link underline hover:cursor-pointer hover:overflow-x-auto"
                      onClick={() => detailView(row[item.key])}
                    >
                      Xem thêm
                    </div>
                  ) : (
                    <div className="h-[5.2vh] overflow-hidden whitespace-nowrap hover:overflow-x-auto">
                      {row[item.key]}
                    </div>
                  )}
                </td>
              ))}
            </tr>
          ))}
          {Array(emptyRowCount)
            .fill(null)
            .map((_, index) => (
              <tr key={`empty-${index}`} className="whitespace-nowrap">
                {selectedList ? (
                  <td className="flex h-[5.8vh] w-[3.33vw] items-center justify-center border border-light-gray px-3">
                    <label className="relative h-6 w-6 cursor-pointer">
                      <input type="checkbox" className="hidden" disabled />
                      <div
                        className={`flex h-5 w-5 items-center justify-center rounded-[4px] border-[3px] border-gray-accent bg-white`}
                      ></div>
                    </label>
                  </td>
                ) : null}
                <td className="h-[5.8vh] border border-lightgray px-3 text-center">
                  {startRowIndex + data.length + index}
                </td>

                {columnMapping.map((_, colIndex) => (
                  <td
                    key={colIndex}
                    className="h-[5.8vh] border border-lightgray px-3"
                  />
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )

  const ActionButtons = () => {
    if (!actionButtons || actionButtons.length === 0) return null
    return (
      <table className="absolute right-0 top-0">
        <thead>
          <tr>
            <th
              colSpan={2}
              className="h-[5.8vh] w-24 items-center border border-lightgray bg-ivory text-center"
            >
              <p className="flex h-[5.8vh] items-center justify-center text-sm leading-tight">
                Hành động
              </p>
            </th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={row.id || rowIndex}>
              {actionButtons.map((button, index) => {
                let iconShow = button.icon
                if (button.title === 'Vô hiệu hóa') {
                  iconShow =
                    row.status === 'INACTIVE' ? (
                      <MdVisibilityOff className="text-2xl text-main-grey" />
                    ) : (
                      button.icon
                    )
                }
                return (
                  <td
                    key={`action-${index}`}
                    className="sticky h-[5.8vh] w-24 border border-lightgray bg-white"
                  >
                    <div className="flex justify-center">
                      <button
                        onClick={() => button.onClick(row)}
                        className="rounded-full hover:bg-gray-100"
                        title={button.label}
                      >
                        {iconShow}
                      </button>
                    </div>
                  </td>
                )
              })}
            </tr>
          ))}
          {Array(emptyRowCount)
            .fill(null)
            .map((_, rowIndex) => (
              <tr key={`empty-action-${rowIndex}`}>
                {actionButtons.map((_, colIndex) => (
                  <td
                    key={`empty-action-${colIndex}`}
                    className="sticky h-[5.8vh] w-24 border border-lightgray bg-white"
                  />
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    )
  }

  return (
    <div className="relative">
      <MainTable />
      <ActionButtons />
    </div>
  )
}

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  itemName,
}) => {
  const [pageInput, setPageInput] = React.useState(currentPage)
  React.useEffect(() => {
    setPageInput(currentPage)
  }, [currentPage])

  const handleInputChange = (e) => {
    const value = e.target.value
    if (/^\d*$/.test(value)) {
      setPageInput(value)
    }
  }

  const handleInputBlur = () => {
    const page = Math.max(
      1,
      Math.min(Number(pageInput) || currentPage, totalPages)
    )
    setPageInput(page)
    if (page !== currentPage) {
      onPageChange(page)
    }
  }
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleInputBlur()
    }
  }
  return (
    <>
      <div className="flex-grow text-center">
        <span className="text-gray-600">
          {`Đang hiển thị ${totalItems} ${itemName}`}
        </span>
      </div>
      <div className="mt-2 flex items-center">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="rounded-md py-1 pr-4"
        >
          <Icon
            icon="ph:caret-left"
            className={`global-icon mx-auto ${currentPage === 1 ? 'text-[#909090]' : 'text-black'}`}
          />
        </button>

        <div className="flex w-[4rem] cursor-pointer justify-center text-center text-lg font-semibold">
          <input
            type="text"
            value={pageInput}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyDown={handleKeyDown}
            className="min-w-[5ch] rounded-md text-center disabled:bg-transparent"
            disabled={currentPage === totalPages}
          />
          <span>/</span>
          <span className="min-w-[5ch]">{totalPages || 1}</span>
        </div>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          className="rounded-md py-1 pl-4"
        >
          <Icon
            icon="ph:caret-right"
            className={`global-icon mx-auto ${
              currentPage === totalPages || totalPages === 0
                ? 'text-[#909090]'
                : 'text-black'
            }`}
          />
        </button>
      </div>
    </>
  )
}

const TableData = ({
  data,
  columnMapping = [],
  columnWidths = {},
  detailView,
  actionButtons = [],
  paginationEnabled = true,
  extraFunctions = [],
  dataType = '',
  currentPage,
  totalPages,
  // onPageChange,
  pageSize = 10,
  totalItems,
  path = '',
  // select box in table
  selectedList = null,
  toggleSelect,
  selectAll,
  toggleSelectAll,
}) => {
  const emptyRowCount = Math.max(0, pageSize - data.length)
  const { queryParams } = useParseQuery()
  const navigate = useNav()
  // vì pagination trong backend là 0-based nhưng hiển thị trên frontend từ 1
  const onPageChange = (value) => {
    navigate(path, {
      params: {
        ...queryParams,
        pageNumber: value,
      },
    })
  }
  const isBorrow = localStorage.getItem('isBorrow')
  const isDataBookBorrow = isBorrow
    ? isBorrow
    : localStorage.getItem('isBorrowBookInfo')
  const checkBorrow = isDataBookBorrow ? true : false
  return (
    <div className="mt-4 flex flex-col space-y-2">
      <div className="relative overflow-x-auto">
        <Table
          data={data}
          startRowIndex={currentPage * pageSize - 10 + 1}
          columnMapping={columnMapping}
          columnWidths={columnWidths}
          detailView={detailView}
          actionButtons={actionButtons}
          emptyRowCount={emptyRowCount}
          selectedList={selectedList}
          toggleSelect={toggleSelect}
          selectAll={selectAll}
          toggleSelectAll={toggleSelectAll}
          checkBorrow={checkBorrow}
        />
      </div>

      <div className="flex items-center justify-between">
        <div className="flex flex-wrap gap-2">
          {extraFunctions.map((func, index) =>
            (selectedList?.size === 0 && index === 1) ||
            (selectedList !== null &&
              selectedList?.size !== 0 &&
              index === 0) ? null : (
              <div key={index}>{func}</div>
            )
          )}
        </div>

        {paginationEnabled && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            totalItems={totalItems}
            itemName={dataType}
          />
        )}
      </div>
    </div>
  )
}

export default TableData
